import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { UserInfo } from '../models/user';
import { QuickPayInfo } from '../models/quickpay';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (!request.url.toLowerCase().includes(environment.restAPI.urlSuffix.toLowerCase())) {
      return next.handle(request);
    }

    const storedUserInfo = sessionStorage.getItem('userInfo');
    const userInfo: UserInfo = storedUserInfo ? JSON.parse(storedUserInfo) : null;
    const tokenIsValid = userInfo
      && userInfo.sessionToken
      && userInfo.accessTokenExpiresAtUtc
      && new Date(userInfo.accessTokenExpiresAtUtc).getTime() > Date.now();

    const storedQuickPayInfo = sessionStorage.getItem('quickPayInfo');
    const quickPayInfo: QuickPayInfo = storedQuickPayInfo ? JSON.parse(storedQuickPayInfo) : null;
    const requestUrl = request.url.toLowerCase();
    const isQuickPayRequest = requestUrl.includes('/quickpay/')
      && !requestUrl.includes('/quickpay/checkpartiid')
      && !requestUrl.includes('/quickpay/checkpartilnamezip');
    const isQuickPayEligible = isQuickPayRequest || requestUrl.includes('/reference/payoffamount');
    const quickPayTokenIsValid = isQuickPayEligible
      && quickPayInfo
      && quickPayInfo.sessionToken
      && quickPayInfo.quickPayTokenExpiresAtUtc
      && new Date(quickPayInfo.quickPayTokenExpiresAtUtc).getTime() > Date.now();

    const authorizationToken = quickPayTokenIsValid
      ? quickPayInfo.sessionToken
      : tokenIsValid ? userInfo.sessionToken : null;
    const authenticatedRequest = authorizationToken
      ? request.clone({ setHeaders: { Authorization: `Bearer ${authorizationToken}` } })
      : request;

    return next.handle(authenticatedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (isQuickPayEligible && quickPayInfo) {
            sessionStorage.removeItem('quickPayInfo');
            this.router.navigateByUrl('/quickpay');
          } else {
            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('logonUserInfo');
            this.router.navigateByUrl('/login');
          }
        }
        return throwError(error);
      })
    );
  }
}